import { ApolloError } from '@apollo/client';

type ValidationError = Record<string, string[]>;

export function getErrorType(error: ApolloError): string | null {
    return error.graphQLErrors.reduce((acc, value) => {
        if (value.extensions?.['type']) {
            return value.extensions['type'];
        }
    }, null);
}

export function getValidationErrors(error: ApolloError | undefined) {
    return error?.graphQLErrors.reduce((acc, value) => {
        if (value.extensions?.['validationErrors']) {
            return value.extensions['validationErrors'];
        }
    }, {});
}

export function getValidationError(error: ApolloError, field: string): string | null {
    const errors = getValidationErrors(error);

    if (!errors || Object.keys(errors).length === 0) {
        return null;
    }

    return (errors as ValidationError)[field]?.[0] || null;
}
